export default class Range {

    constructor() {
        this.rangeEl = document.getElementById('water-usage-slider');

        if (! this.rangeEl) {
          console.log('range el not found');
            return;
        }

        this.rangeChange();
    }

    rangeChange() {

      this.rangeEl.addEventListener('change', function(ev) {

          window.waterRangeValue = this.value;

          window.ribbonMessages.forEach((line) => {

          });

      });
    }

}
